import React from 'react';

import { LinkCard, getCardPaths } from './link_card';

import type { LinkCardRecord } from './link_card';
import type { ResearchPropertyToolCall } from '../types';

interface ResearchPropertyCard extends LinkCardRecord {
  address: string | null;
  displayName: string | null;
}

interface ResearchPropertyCardsProps {
  toolCalls: ResearchPropertyToolCall[];
}

export function ResearchPropertyCards({ toolCalls }: ResearchPropertyCardsProps) {
  return (
    <>
      {getCardPaths(toolCalls).map(path => (
        <LinkCard key={path} path={path}>
          {(property: ResearchPropertyCard) => (
            <>
              <div className="fw-semibold text-truncate">{property.displayName}</div>
              {property.address && <div className="small text-muted text-truncate">{property.address}</div>}
            </>
          )}
        </LinkCard>
      ))}
    </>
  );
}
